const block=(x,y,width,depth=1.5,feature='cut-stone')=>({x,y,width,depth,side:0,feature});
// `edge` is how far the ledge reaches past the centre line. Keep the original
// equation so Windward geometry and authored Quarry clearances mean the same
// thing: a positive edge leaves the inner face at -edge (or +edge mirrored).
const shelf=(side,edge,y,depth=1.2,feature='quarry-shelf')=>({x:side*(5.6-edge)/2,y,width:5.6+edge,depth,side,feature});

// The quarry is a ten-climb curriculum, not a shuffled obstacle set. Geometry
// is written in a common orientation and mirrored with the exposed landing so
// the named decision survives either direction.
export function quarryLayout(id,h,mirror){
  const arrangements=[
    [shelf(1,.3,h*.48,1.25,'lamp-shelf')],
    [block(.55,h*.28,3.4,2.15,'loose-roof'),shelf(-1,.7,h*.66,1.15,'return-shelf')],
    [block(0,h*.29,2.5,2.2,'split-stone'),block(-1.25,h*.60,3.25,1.65,'hanging-mass')],
    [shelf(1,.65,h*.27,1.1,'lower-shelf'),shelf(-1,.85,h*.52,1.15,'middle-shelf'),block(.8,h*.74,2.7,1.6,'cap-stone')],
    [block(-.75,h*.31,3.55,2.1,'marked-pocket'),shelf(-1,1.15,h*.57,1.2,'blind-roof'),block(-1.75,h*.68,2.5,1.1,'outer-key')],
    [block(.2,h*.30,3.55,3.15,'broad-pillar'),shelf(-1,.55,h*.60,1.25,'high-return')],
    [block(1.45,h*.27,2.75,2.25,'right-load'),block(-1.45,h*.51,2.75,2.2,'left-load'),shelf(1,.6,h*.74,1.1,'balance-cap')],
    [shelf(1,.55,h*.34,1.1,'cable-housing'),block(-.55,h*.54,.9,2.1,'brace-anchor'),shelf(-1,.7,h*.75,1.05,'service-ledge')],
    [block(-1.35,h*.24,2.85,2.05,'lower-bay'),shelf(-1,.95,h*.47,1.15,'false-bay'),block(1.35,h*.67,3.05,1.85,'upper-bay')],
    [block(.35,h*.22,3.6,2.2,'crown-foot'),shelf(1,.7,h*.43,1.1,'false-chute'),block(-1.35,h*.61,3,1.75,'crown-lock'),shelf(-1,.8,h*.79,1.05,'crown-rim')],
  ];
  const puzzles=[
    'Skirt the solid shelf and approach the landing from its exposed edge.',
    'Commit around the low roof, then cross back above the opposing shelf.',
    'Choose the far face of the split stone and counterweight the return.',
    'Read and build an alternating three-turn switchback.',
    'Climb the pocket’s open face, then cross above the blind roof.',
    'Establish a low cantilever before climbing the broad pillar.',
    'Alternate short arms so the two hanging loads balance each other.',
    'Brace against the old anchor, descend its face, and pass below the housing.',
    'Thread the two offset bays, reversing direction between them.',
    'Counterbalance the foot, escape the false chute, then switch across the crown.',
  ];
  const signals=[
    [-2.1,h*.48+.8],[-2.1,h*.66+1.06],[-2.1,h*.60+1],[-2.1,h*.52+.9],[-2.1,h*.68+1],
    [-2.9,h*.30+2.5],[2.2,h*.51+1.4],[-2.2,h*.54+1.4],[2.2,h*.47+1.3],[1.8,h*.79+1],
  ];
  return {
    routeSet:'quarry',routeFamily:id,puzzle:puzzles[id],
    obstacles:arrangements[id].map(o=>({...o,x:o.x*mirror,side:o.side*mirror})),
    flag:{x:signals[id][0]*mirror,y:Math.min(h-1.05,signals[id][1])},
  };
}

// Windward retains its established six physical route families while the first
// production pass stays concentrated on the Quarry.
export function forkLayout(id,h,mirror){
  const family=(id-2)%6;
  const arrangements=[
    [block(.45,4.5,2.8),shelf(-1,.6,h*.6)],
    [block(.45,4.5,2.8),block(-2,h*.5,3),shelf(1,.4,h*.77)],
    [block(.45,4.5,2.8),block(-1,h*.56,3.4)],
    [block(-.5,4.5,3.2),shelf(1,1,h*.50),block(-2,h*.70,2.7)],
    [block(.75,4.5,3.2),block(-1.4,h*.46,3.1),block(1.2,h*.72,3.4)],
    [block(-.35,4.5,3),block(1.5,h*.43,3),shelf(-1,.85,h*.65),block(2,h*.81+.6,2.7)],
  ];
  return {
    routeSet:'windward',routeFamily:family,
    obstacles:arrangements[family].map(o=>({...o,x:o.x*mirror,side:o.side*mirror,depth:o.depth+.2})),
    flag:{x:-1.86*mirror,y:5.3},
  };
}
